import Location from '@r6digital/rapidstor-types/react/entities/Location';

import { MoveInSocketData, SocketStatus } from '@/core/types/Socket';

import useSettlementSocket from '@/core/hooks/useSettlementSocket';

interface UseMoveInSocketParams {
    location: Location;
}

export interface MoveInCompletionHandlers {
    onSuccess?: (result: MoveInSocketData) => void;
    onFailure?: (result: MoveInSocketData) => void;
    onTimeout?: () => void;
}

interface UseMoveInSocketReturn {
    startListening: (reservationId: string, handlers?: MoveInCompletionHandlers) => void;
    stopListening: () => void;
    latestResult: MoveInSocketData | null;
    status: SocketStatus;
}

/**
 * Listens for the regular (non-SCA) `moveInEvent` on the `move-in:{reservationId}` room.
 * The move-in itself runs server-side once R6Pay's webhook lands, so this is how the
 * browser learns the outcome. See `useSettlementSocket` for the shared plumbing.
 */
export const useMoveInSocket = ({
    location,
}: UseMoveInSocketParams): UseMoveInSocketReturn => useSettlementSocket<'move-in'>({
    location,
    roomType: 'move-in',
    roomPrefix: 'move-in',
    logPrefix: '[useMoveInSocket]',
});

export default useMoveInSocket;
